import React from 'react';

export default class division extends React.Component {

    constructor(props) {
        super(props);
    }


    render() {
        const { id, label,  attributes } = this.props;
        const stilo = {display: !!attributes.hidden ?  attributes.hidden :'unset' };
        return (
            <div className="col-md-12" style={stilo}>
                <div className="form-group">            
                    <h3 id={id} >{label}</h3>
                </div>
            </div>            
        )
    }
}
